(function() {
      var rotator = document.querySelector('[data-announcement-rotator]');
      if (!rotator) return;
      var slides = rotator.querySelectorAll('.announcement-center__slide');
      if (slides.length < 2) return;

      var interval = (parseInt(rotator.getAttribute('data-interval'), 10) || 10) * 1000;
      var current = 0;

      // если первый слайд пуст (text_center не заполнен), активируем первый существующий
      if (!rotator.querySelector('.announcement-center__slide.is-active')) {
        slides[0].classList.add('is-active');
      }

      setInterval(function() {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, interval);
    })();
